import { render, staticRenderFns } from "./LocalUnitSaveEditDialog.vue?vue&type=template&id=5266e930"
import script from "./LocalUnitSaveEditDialog.vue?vue&type=script&lang=js"
export * from "./LocalUnitSaveEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports